jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
    const badgeTexts = {
         sale: T4SProductStrings.badgeSale,
         new: T4SProductStrings.badgeNew,
         preOrder: T4SProductStrings.badgepreOrder,
         soldout: T4SProductStrings.badgeSoldout,
         SavePercent: T4SProductStrings.badgeSavePercent
      };
    $("body").on("click", ".t4-variant-custom", function () {
      const _this = $(this);
      const product = _this.data("product");
      const wrapper = _this.closest(".t4s-product");
      var badges = $(wrapper).find('[data-product-badge]');
      $(wrapper).find(".t4-variant-custom").removeClass("is-swatch--selected");
      _this.addClass("is-swatch--selected");
      $(wrapper).find(".t4s-product-main-img").attr("data-srcset", product.featured_image);
      $(wrapper).find(".t4s-product-hover-img").attr("data-srcset", product.images[1]);
      $(wrapper).find(".t4s-product-title a").attr("href", _this.data("url")).text(product.title);
      $(wrapper).find(".t4s-full-width-link").attr("href", _this.data("url"));
      $(wrapper).find(".t4s-pr-addtocart").attr("data-variant-id", product.variants[0].id).attr("data-id", product.id).attr("href", _this.data("url"));
      $(wrapper).find(".t4s-pr-quickview").attr("data-id", product.id).attr("href", _this.data("url"));
      if(product.available) {
         $(wrapper).find(".t4s-pr-addtocart").attr("data-action-atc", true);
         $(wrapper).find(".t4s-pr-addtocart .t4s-text-pr").html(T4SProductStrings.addToCart);
        $(wrapper).find(".t4s-badge-soldout").hide();
      } else {
        const sold = $(badges).find('.t4s-badge-soldout');
        if(sold.length > 0) {
          $(sold).show();
        }
        else {
          $(badges).html('<span data-badge-soldout class="t4s-badge-item t4s-badge-soldout">'+badgeTexts['soldout']+'</span>');
        }

        $(wrapper).find(".t4s-badge-soldout").show();
        $(wrapper).find(".t4s-pr-addtocart").removeAttr("data-action-atc");
        $(wrapper).find(".t4s-pr-addtocart .t4s-text-pr").html(T4SProductStrings.readMore);
      }
      if (product.price_varies) {
        $(wrapper)
          .find(".t4s-product-price")
          .html(_this.data("price-min") + "-" + _this.data("price-max"));
      } else {
        if (product.price < product.compare_at_price) {
          $(wrapper).find(".t4s-product-price").html(`<del>${_this.data("compare-price")}</del><ins>${_this.data("price")}</ins>`);
          $(wrapper).find(".t4s-badge-sale").show();
          let discount = Math.round(((product.compare_at_price - product.price) * 100 / product.compare_at_price));
          //console.log(discount);
          $(wrapper).find(".t4s-badge-sale").html(`-${discount}%`);
        } else {
          $(wrapper).find(".t4s-product-price").html(_this.data("price"));
          $(wrapper).find(".t4s-badge-sale").hide();
        }
  
      }
      //console.log(product);
    });

  $(window).on('scroll',function(){
    $('body').css({'--header-h-scroll': `${$('header').height()}px`})
  })
});


